export const ACCESS_LEVEL_ENTITY = {
    WORKSPACE: 1,
    PROJECT: 2,
    DOCUMENT: 3
};
